export default defineNuxtRouteMiddleware(() => {
	const routeUrl = useRouteUrl()
	const userStore = useUserStore()
	if (userStore.token && userStore.user?.status === "enable" && ["company-user"].includes(userStore.user?.type)) {
		return navigateTo(routeUrl.CompanyDashboardUrl())
	}
})
